import React from 'react'
import { Box, ButtonBase, Typography } from '@mui/material'

/**
 * MUI implementation of the wireframed View/Mode toggle control.
 *
 * Contract:
 * - viewMode: 'monthly' | 'weekly'
 * - calcMode: 'allocate' | 'aggregate'
 */
function PlanViewModeToggle({ viewMode, onViewModeChange, calcMode, onCalcModeChange }) {
  const groupSx = {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
  }

  const pillWrapSx = {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#f3f4f6',
    borderRadius: '8px',
    padding: '4px',
    gap: '4px',
  }

  const pillBtnSx = (active) => ({
    borderRadius: '6px',
    padding: '6px 12px',
    fontSize: '12px',
    fontWeight: 600,
    lineHeight: 1,
    backgroundColor: active ? '#111827' : 'transparent',
    color: active ? '#ffffff' : '#4b5563',
    boxShadow: active ? '0 1px 2px rgba(0,0,0,0.12)' : 'none',
    transition: 'background-color 150ms, color 150ms',
    '&:hover': {
      backgroundColor: active ? '#111827' : 'rgba(17,24,39,0.06)',
      color: active ? '#ffffff' : '#111827',
    },
  })

  const labelSx = {
    fontSize: '12px',
    color: '#6b7280',
    fontWeight: 600,
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 3, flexWrap: 'wrap' }}>
      <Box sx={groupSx}>
        <Typography sx={labelSx}>View:</Typography>
        <Box sx={pillWrapSx}>
          <ButtonBase
            type="button"
            onClick={() => onViewModeChange('monthly')}
            data-testid="plan-view-monthly"
            sx={pillBtnSx(viewMode === 'monthly')}
          >
            12 Months
          </ButtonBase>
          <ButtonBase
            type="button"
            onClick={() => onViewModeChange('weekly')}
            data-testid="plan-view-weekly"
            sx={pillBtnSx(viewMode === 'weekly')}
          >
            12 Weeks
          </ButtonBase>
        </Box>
      </Box>

      <Box sx={groupSx}>
        <Typography sx={labelSx}>Mode:</Typography>
        <Box sx={pillWrapSx}>
          <ButtonBase
            type="button"
            onClick={() => onCalcModeChange('allocate')}
            data-testid="plan-calc-allocate"
            sx={pillBtnSx(calcMode === 'allocate')}
          >
            Allocate
          </ButtonBase>
          <ButtonBase
            type="button"
            onClick={() => onCalcModeChange('aggregate')}
            data-testid="plan-calc-aggregate"
            sx={pillBtnSx(calcMode === 'aggregate')}
          >
            Aggregate
          </ButtonBase>
        </Box>
      </Box>
    </Box>
  )
}

export default PlanViewModeToggle

